module.exports = __webpack_public_path__ + "static/media/ls.3b26ed06.svg";